import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Stack } from "@mui/material";
import React from "react";
import { translate } from "../../../providers";
import styles from "./CustomDatePicker.module.css";

const CustomDatePicker = ({
	className = "",
	clearable = false,
	error = false,
	fullWidth = false,
	inputFormat = "dd/MM/yyyy",
	label = "",
	minDate = "",
	slotProps = {},
	onBlur,
	onChange,
	onClose,
	onFocus,
	renderInput,
	value = new Date(),
	...otherProps
}) => (
	<div className={`${styles.datePicker} ${fullWidth ? styles["datePicker--fullWidth"] : ""} ${className}`}>
		<Stack>
			<DatePicker
				cancelText={translate("common:btn.cancel")}
				clearable={clearable}
				clearText={translate("common:btn.clear-select")}
				componentsProps={{ textField: { variant: "outlined", onFocus, onBlur } }}
				error={error}
				format={inputFormat}
				label={label}
				minDate={minDate}
				okText={translate("common:btn.ok")}
				renderInput={renderInput}
				slotProps={slotProps}
				value={value}
				onChange={onChange}
				onClose={onClose}
				{...otherProps}
			/>
		</Stack>
	</div>
);

export default CustomDatePicker;
